import styled from "styled-components";
import { responsive } from "../../../styles/constants.style";

export const CPDashboardMainWrapper = styled.div`
  display: flex;
  gap: 24px;
  flex-direction: column;
  padding-bottom: 36px;

  ${responsive.MOBILE`
    gap: 16px;
    padding-bottom: 16px;
  `}
`;
